module.exports = "/assets/data/f733577edb3a5aab055fac00fad6da3c-NG22.data.json";